module.exports = __webpack_public_path__ + "static/media/vegitables_48.86a9087a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_48.csv
// module id = 633
// module chunks = 0